import React, { ReactNode, useEffect, useRef } from "react";
import styled from "styled-components";

/**
 * Hook that alerts clicks outside of the passed ref
 */
function useOutsideCallback(
  ref: React.RefObject<HTMLElement>,
  callback: () => void,
  exceptId = ""
) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: Event) {
      if (
        ref.current &&
        !ref.current.contains(event.target as Element) &&
        (event.target as Element).id !== exceptId
      ) {
        callback();
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref]);
}

/**
 * Component that alerts if you click outside of it
 */

type Props = {
  children: ReactNode;
  callback: () => void;
  authorizedArea?: string;
};

export const OutsideCallback: React.FC<Props> = ({
  children,
  callback = () => {},
  authorizedArea = "",
}) => {
  const wrapperRef = useRef(null);
  // @ts-ignore
  useOutsideCallback(wrapperRef, callback, authorizedArea);

  return (
    <Absolute id="outside" ref={wrapperRef}>
      {children}
    </Absolute>
  );
};

const Absolute = styled.div`
  position: absolute;
`;
